var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.7,0.5H4.7c-1.6,0-3,1.3-3,3v2.3H1.4c-0.5,0-1,0.4-1,1v1.3c0,0.5,0.4,1,1,1h2.7c0.5,0,1-0.4,1-1V6.8c0-0.5-0.4-1-1-1 H2.4V3.5c0-1.3,1-2.3,2.3-2.3h13.9c1.3,0,2.3,1,2.3,2.3v15.3c0,1.3-1,2.3-2.3,2.3H4.7c-1.3,0-2.3-1-2.3-2.3v-1.7 c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v1.7c0,1.6,1.3,3,3,3h13.9c1.6,0,3-1.3,3-3V3.5C21.7,1.9,20.3,0.5,18.7,0.5z  M4.4,6.8v1.3c0,0.2-0.1,0.3-0.3,0.3H1.4c-0.2,0-0.3-0.1-0.3-0.3V6.8c0-0.2,0.1-0.3,0.3-0.3h2.7C4.3,6.5,4.4,6.6,4.4,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,15.5v-1.3c0-0.5-0.4-1-1-1H2.4V9.8c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3v3.3H1.4c-0.5,0-1,0.4-1,1v1.3 c0,0.5,0.4,1,1,1h2.7C4.6,16.5,5.1,16,5.1,15.5z M1.1,15.5v-1.3c0-0.2,0.1-0.3,0.3-0.3h2.7c0.2,0,0.3,0.1,0.3,0.3v1.3 c0,0.2-0.1,0.3-0.3,0.3H1.4C1.2,15.8,1.1,15.6,1.1,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,14.1v0.7c0,0.9,0.7,1.7,1.7,1.7h6c0.9,0,1.7-0.7,1.7-1.7v-0.7c0-1.6-1.2-2.9-2.8-3c0.7-0.5,1.1-1.4,1.1-2.3 c0-1.6-1.3-3-3-3s-3,1.3-3,3c0,0.9,0.4,1.8,1.1,2.3C8.3,11.3,7.1,12.6,7.1,14.1z M9.4,8.8c0-1.3,1-2.3,2.3-2.3s2.3,1,2.3,2.3 s-1,2.3-2.3,2.3S9.4,10.1,9.4,8.8z M10.1,11.8h3.3c1.3,0,2.3,1,2.3,2.3v0.7c0,0.5-0.4,1-1,1h-6c-0.5,0-1-0.4-1-1v-0.7 C7.7,12.8,8.8,11.8,10.1,11.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.e21decc3.svg";
export { ForwardRef as ReactComponent };